<template>
    <ModalBase
        :name="name"
        :title="isEdit ? 'Editar categoría ' + (modelValue?.name || '') : 'Crear categoría'"
        @close="$emit('close')"
    >
        <CategoriaForm
            v-if="modelValue"
            :initial-data="modelValue"
            :submit-label="isEdit ? 'Actualizar' : 'Guardar'"
            :loading="props.loading"
            @submit="handleSave"
        />
    </ModalBase>
</template>

<script setup>
    import { computed } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import CategoriaForm from './CategoriaForm.vue'

    const props = defineProps({
        name: { type: String, required: true },
        modelValue: { type: Object, default: null },
        loading: { type: Boolean, default: false }
    })
    const emit = defineEmits(['update:modelValue', 'save', 'close'])

    const isEdit = computed(() => !!props.modelValue?.id)

    function handleSave(formData) {
        const data = props.modelValue?.id ? { ...formData, id: props.modelValue.id } : formData
        emit('save', data)
    }
</script>
